module.exports = __webpack_public_path__ + "static/media/upload.32e988d1.png";